export default [
  {
    path: '/2021/report/doc',
    component: () => import('./views/report/doc')
  }
]



// WEBPACK FOOTER //
// ./src/page/2021/route.js